<template>
  <v-card class="mx-auto mt-1" min-width="1280px" max-width="100vw" outlined>
    <v-row
      class="mx-0 mt-0 white--text"
      style="background-color:#303032;font-size:22px;height: 260px"
    >
      <v-col cols="7">
        <v-row class="mt-0">
          <v-col class="pl-10 display-1 text-center"
            >สถานการณ์อุบัติเหตุบนโครงข่ายของกระทรวงคมนาคม</v-col
          >
        </v-row>
        <v-row class="justify-center align-center mt-4"
          ><!-- remove mt-4 when compare-->
          <v-col cols="3"></v-col
          ><!-- cols="3" when compare-->
          <v-col cols="3">
            <DatePicker
              v-model="startDate"
              :max="today"
              @input="changeDate(utils.startDateChanged(startDate, endDate), false)"
              :defaultDate="startDate"
              ref="startDate"
              :invert="true"
              bgColor="#515052"
              :hideclearbtn="true"
            />
          </v-col>
          <v-col cols="1" class="text-center">ถึง</v-col>
          <v-col cols="3">
            <DatePicker
              v-model="endDate"
              :max="today"
              @input="changeDate(utils.endDateChanged(startDate, endDate), false)"
              :defaultDate="endDate"
              ref="endDate"
              :invert="true"
              bgColor="#515052"
              :hideclearbtn="true"
            />
          </v-col>
          <v-col cols="2"> </v-col>
        </v-row>
        <v-row class="justify-center align-center">
          <v-col cols="3" class="text-right">เปรียบเทียบกับ</v-col>
          <v-col cols="3">
            <DatePicker
              v-model="compareStartDate"
              :max="today"
              @input="changeDate(utils.startDateChanged(compareStartDate, compareEndDate), true)"
              :defaultDate="compareStartDate"
              ref="compareStartDate"
              :invert="true"
              bgColor="#515052"
              :hideclearbtn="true"
            />
          </v-col>
          <v-col cols="1" class="text-center">ถึง</v-col>
          <v-col cols="3">
            <DatePicker
              v-model="compareEndDate"
              :max="today"
              @input="changeDate(utils.endDateChanged(compareStartDate, compareEndDate), true)"
              :defaultDate="compareEndDate"
              ref="compareEndDate"
              :invert="true"
              bgColor="#515052"
              :hideclearbtn="true"
            />
          </v-col>
          <v-col cols="2">
            <v-btn
              color="white"
              @click="
                getCompareAccident();
                getMostAccidentRoute();
              "
              >ตกลง</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3" class="d-flex align-center justify-center">
        <span style="font-size:84px">TRAMS</span>
      </v-col>
      <v-col
        cols="2"
        class="py-0 mt-0 pt-0"
        style="background-color:#881300;position:absolute;top:0px;right:16px;border-radius:0px 0px 20px 20px;width:auto"
      >
        <v-row class="mt-0">
          <v-col
            class="d-flex align-center justify-center"
            style="background-color:#E2D8CE;border-radius:0px 0px 20px 20px;height:280px;"
          >
            <v-img
              max-width="240"
              max-height="240"
              :src="require(`@/assets/sumdashboard/All/weblogo.png`)"
            ></v-img>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="text-center mx-0" style="background-color:#C3B3D0">
      <v-col class="display-1">ภาพรวมสถานการณ์อุบัติเหตุทางอากาศ</v-col>
    </v-row>
    <v-row class="mx-0 d-flex" style="background-color:#46352D;">
      <v-col
        cols="3"
        :style="item.bgColor"
        class="py-4 align-center d-flex"
        v-bind:class="{ 'white--text': item.invert }"
        v-for="(item, i) in compareAccident"
        :key="i"
      >
        <v-row class="pl-5 py-0">
          <v-col cols="3" class="d-flex align-center justify-center">
            <v-img max-width="64" max-height="64" :src="item.img"></v-img>
          </v-col>
          <v-col cols="8">
            <v-row>
              <v-col cols="12" class="d-flex flex-column justify-center">
                <div class="text-h4 text-center">{{ item.text }}</div>
              </v-col>
            </v-row>
            <v-row class="py-2">
              <v-col cols="6" class="title text-wrap py-1">ปี {{ item.thisYear }}</v-col>
              <v-col cols="6" class="pa-0">
                <v-row class="d-flex mt-0">
                  <v-col
                    cols="6"
                    class="title text-wrap font-weight-medium py-1 text-center accident-year-count black--text"
                  >
                    {{ item.thisYearAmount || '-' }}
                  </v-col>
                  <v-col cols="6" class="title text-wrap font-weight-medium py-1 text-center">{{
                    item.unit
                  }}</v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="title text-wrap py-1">ปี {{ item.lastYear }}</v-col>
              <v-col cols="6" class="pa-0">
                <v-row class="d-flex mt-0">
                  <v-col
                    cols="6"
                    class="title text-wrap font-weight-medium py-1 text-center accident-year-count black--text"
                  >
                    {{ item.lastYearAmount || '-' }}
                  </v-col>
                  <v-col cols="6" class="title text-wrap font-weight-medium py-1 text-center">{{
                    item.unit
                  }}</v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-col cols="12" class="pt-8 pl-0 d-flex flex-column justify-center">
              <div class="subtitle-1 font-weight-medium">
                {{ item.countText + ' ' + (item.decreaseAmount || '-') + ' ' + item.unit 
                  + ' (' + item.decreasePercentage + ')' }}
              </div>
            </v-col>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="text-center mx-0" style="background-color:#C3B3D0">
      <v-col cols="5" class="bottom-header">บริเวณที่เกิดอุบัติเหตุสูงสุด 5 อันดับ</v-col>
      <v-col class="bottom-header">ข้อมูลปฏิบัติการ</v-col>
      <!-- <v-col class="bottom-header">สาเหตุการเกิดอุบัติเหตุ</v-col> -->
      <!-- <v-col class="bottom-header">ระดับของเหตุการณ์</v-col> -->
    </v-row>
    <v-row class="text-center mx-0 mb-0" style="background-color:white">
      <v-col cols="5" class="px-0 py-0 bottom-content">
        <v-simple-table class="card-border" style="border-bottom:none!important">
          <thead style="background-color:#7971D1">
            <tr>
              <th class="text-center font-weight-regular">ลำดับ</th>
              <th class="text-center font-weight-regular">ชื่อสถานที่</th>
              <th class="text-center font-weight-regular">รหัส</th>
              <th class="text-center font-weight-regular">ครั้ง</th>
              <th class="text-center font-weight-regular">ผู้เสียชีวิต</th>
              <th class="text-center font-weight-regular">ผู้บาดเจ็บ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in mostAccidentRoad" :key="item.order">
              <td>{{ item.order }}</td>
              <td>{{ item.airportName || '-' }}</td>
              <td>{{ item.code || '-' }}</td>
              <td>{{ item.accident || '-' }}</td>
              <td>{{ item.dead || '-' }}</td>
              <td>{{ item.injury || '-' }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
      <v-col
        v-for="(item, i) in flightType"
        class="px-0 text-center mx-0 bottom-content"
        style="background-color:white"
        :key="i"
      >
        <v-row class="mx-0">
          <v-col cols="12" style="background-color:#7971D1">{{ item.text }}</v-col>
        </v-row>
        <v-row class="mx-0">
          <v-col cols="12" class="d-flex align-center justify-center">
            <v-img max-width="100" max-height="100" :src="item.img"></v-img>
          </v-col>
        </v-row>
        <v-row class="mx-0" style="color:#322292">
          <v-col cols="12" class="display-1">{{ item.amount || '-' }}</v-col>
        </v-row>
        <v-row class="mx-0" style="color:#322292">
          <v-col cols="12" class="headline">ครั้ง</v-col>
        </v-row>
      </v-col>
      <!-- <v-col class="px-0 py-0 text-center mx-0 bottom-content" style="background-color:white">
        <v-row class="mx-0">
            <v-col cols="12" style="background-color:#7971D1">การบินทั่วไป</v-col>
        </v-row>
      </v-col>
      <v-col class="px-0 py-0 text-center mx-0 bottom-content" style="background-color:white">
        <v-row class="mx-0">
            <v-col cols="12" style="background-color:#7971D1">อื่นๆ</v-col>
        </v-row>
      </v-col> -->
    </v-row>
  </v-card>
</template>

<script>
import DatePicker from '../global/DatePicker';

export default {
  name: 'ExecutiveAirReport',
  components: {
    DatePicker
  },
  data: () => ({
    today: null,
    compareStartDate: null,
    compareEndDate: null,
    startDate: null,
    endDate: null,
    compareAccident: [
      {
        img: require('@/assets/sumdashboard/air/airliner__1_@2x.png'),
        text: 'อุบัติเหตุ',
        countText: 'ลดลง',
        unit: 'ครั้ง',
        decreaseAmount: 0,
        decreasePercentage: 0.0,
        thisYearAmount: 0,
        lastYearAmount: 0,
        bgColor: 'background-color:#6A5695;',
        invert: true
      },
      {
        img: require('@/assets/sumdashboard/air/air@2x.png'),
        text: 'อุบัติการณ์', // รุนแรง
        countText: 'ลดลง',
        unit: 'ครั้ง',
        decreaseAmount: 0,
        decreasePercentage: 0.0,
        thisYearAmount: 0,
        lastYearAmount: 0,
        bgColor: 'background-color:#7971D1;',
        invert: false
      },
      {
        img: require('@/assets/sumdashboard/road/dead@2x.png'),
        text: 'ผู้เสียชีวิต',
        countText: 'ลดลง',
        unit: 'คน',
        decreaseAmount: 0,
        decreasePercentage: 0.0,
        thisYearAmount: 0,
        lastYearAmount: 0,
        bgColor: 'background-color:#B191C2',
        invert: false
      },
      {
        img: require('@/assets/sumdashboard/road/man_with_arm_injury@2x.png'),
        text: 'ผู้บาดเจ็บ',
        countText: 'ลดลง',
        unit: 'คน',
        decreaseAmount: 0,
        decreasePercentage: 0.0,
        thisYearAmount: 0,
        lastYearAmount: 0,
        bgColor: 'background-color:#C4B5EE;',
        invert: false
      }
    ],
    mostAccidentRoad: [],
    flightType: [
      {
        text: 'การบินพานิชย์',
        img: require('@/assets/sumdashboard/air/air-freight@2x.png'),
        amount: 0
      },
      {
        text: 'การบินทั่วไป',
        img: require('@/assets/sumdashboard/air/aeroplane@2x.png'),
        amount: 0
      },
      {
        text: 'อื่นๆ',
        img: require('@/assets/sumdashboard/air/airplane-ticket@2x.png'),
        amount: 0
      }
    ],
    typeByOrder: [],
    causeByOrder: [],
    sumAccident: 0,
    isInitial: true
  }),
  created() {},
  mounted() {
    const period = JSON.parse(localStorage.getItem('execParams'));
    if (period) {
      localStorage.removeItem('execParams');
      this.$refs.startDate.setDefaultData(period.startDate);
      this.$refs.endDate.setDefaultData(period.endDate);
      period.startDate = period.startDate.split('-');
      period.endDate = period.endDate.split('-');
      const startDateYear = Number(period.startDate.splice(0, 1)[0]);
      const endDateYear = Number(period.endDate.splice(0, 1)[0]);
      this.$refs.compareStartDate.setDefaultData((startDateYear - 1) + '-' + period.startDate.join('-'));
      this.$refs.compareEndDate.setDefaultData((endDateYear - 1) + '-' + period.endDate.join('-'));
      for (let i = 0; i < this.compareAccident.length; i++) {
        this.compareAccident[i].thisYear = endDateYear + 543;
        this.compareAccident[i].lastYear = endDateYear - 1 + 543;
      }
      this.getCompareAccident();
      this.getMostAccidentRoute();
    }
    else {
      const date = this.utils.getLocalDate();
      this.today = date;
      this.compareStartDate = date;
      this.compareEndDate = date;
      this.startDate = date;
      this.endDate = date;
      for (let i = 0; i < this.compareAccident.length; i++) {
        this.compareAccident[i].thisYear = Number(date.split('-')[0]) + 543;
        this.compareAccident[i].lastYear = Number(date.split('-')[0]) + 543;
      }
      this.getDefaultFestival();
    }
  },
  methods: {
    getDefaultFestival() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/festival/default`;
      this.axios.get(url).then(response => {
        const res = response.data.data;
        const defaultfes = res.filter(member => {
          return member.isdefault;
        })[0];
        this.startDate = defaultfes.start_date.split(' ')[0];
        this.endDate = defaultfes.end_date.split(' ')[0];
        if (defaultfes.compare_start_date) {
          this.compareStartDate = defaultfes.compare_start_date.split(' ')[0];
        } else {
          const td = new Date(this.startDate);
          td.setFullYear(td.getFullYear() - 1);
          this.compareStartDate = this.utils.getLocalDate(td);
        }
        if (defaultfes.compare_end_date) {
          this.compareEndDate = defaultfes.compare_end_date.split(' ')[0];
        } else {
          const td = new Date(this.endDate);
          td.setFullYear(td.getFullYear() - 1);
          this.compareEndDate = this.utils.getLocalDate(td);
        }
        this.getCompareAccident();
        this.getMostAccidentRoute();
      });
    },
    getCompareAccident() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/category/air`;
      this.axios
        .get(url, {
          params: {
            start_date: this.startDate,
            end_date: this.endDate,
            report_date:this.utils.getLocalDate(),
          }
        })
        .then(response => {
          const res = response.data.data;
          this.sumAccident = response.data.data.accident;
          this.compareAccident.forEach(element => {
            element.thisYear = parseInt(response.data.meta.end_date.substr(0, 4), 10) + 543;
          });

          this.compareAccident[0].thisYearAmount = res.accident;
          this.compareAccident[1].thisYearAmount = res.incident;
          this.compareAccident[2].thisYearAmount = res.dead;
          this.compareAccident[3].thisYearAmount = res.injury;

          this.getLastYearAccident();
          this.getType();
        });
    },
    getLastYearAccident() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/category/air`;
      this.axios
        .get(url, {
          params: {
            start_date: this.compareStartDate,
            end_date: this.compareEndDate,
            report_date:this.utils.getLocalDate(),
          }
        })
        .then(response => {
          const res = response.data.data;
          this.compareAccident.forEach(element => {
            element.lastYear = parseInt(response.data.meta.end_date.substr(0, 4), 10) + 543;
          });

          this.compareAccident[0].lastYearAmount = res.accident;
          this.compareAccident[1].lastYearAmount = res.incident;
          this.compareAccident[2].lastYearAmount = res.dead;
          this.compareAccident[3].lastYearAmount = res.injury;

          this.compareAccident.forEach(element => {
            element.decreaseAmount = Math.abs(element.lastYearAmount - element.thisYearAmount);
            if (element.lastYearAmount > element.thisYearAmount) {
              element.countText = 'ลดลง';
              if (element.lastYearAmount > 0)
                element.decreasePercentage = `${(
                  (1 - element.thisYearAmount / element.lastYearAmount) *
                    100
                ).toFixed(2)}%`;
              else element.decreasePercentage = '0.00%';
            } else {
              element.countText = 'เพิ่มขึ้น';
              if (element.thisYearAmount > 0)
                element.decreasePercentage = `${(
                  (1 - element.lastYearAmount / element.thisYearAmount) * 100
                ).toFixed(2)}%`;
              else element.decreasePercentage = '0.00%';
            }
          });
        });
    },
    getMostAccidentRoute() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/executive/air/list`;
      this.mostAccidentRoad = [];
      for (let i = 1; i <= 5; i++) {
        this.mostAccidentRoad.push({
          order: i,
          airportName: null,
          code: null,
          accident: 0,
          dead: 0,
          injury: 0
        });
      }
      this.axios
        .get(url, {
          params: {
            start_date: this.startDate,
            end_date: this.endDate,
            hasname: true,
            report_date:this.utils.getLocalDate(),
          }
        })
        .then(response => {
          const res = response.data.data;
          this.mostAccidentRoad.forEach((element, i) => {
            if (!(i in res)) {
              element.routeName = '-';
              element.type = '-';
            } else {
              element.airportName = res[i].airport_name || '-';
              element.code = res[i].code || '-';
              element.accident = res[i].accident;
              element.dead = res[i].dead;
              element.injury = res[i].injury;
            }
          });
          this.isInitial = false;
        });
    },
    getType() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/executive/air/type`;
      this.axios
        .get(url, {
          params: {
            start_date: this.startDate,
            end_date: this.endDate,
            report_date:this.utils.getLocalDate(),
          }
        })
        .then(response => {
          const res = response.data.data;
          this.flightType = this.flightType.map(el => {
            el.amount = 0;
            return el;
          }); 
          res.forEach((element, i) => {
            if (element.operation_type.includes('Non-Commercial')) {
              this.flightType[1].amount += parseInt(element.accident, 10);
            } else if (element.operation_type.includes('Commercial')) {
              this.flightType[0].amount += parseInt(element.accident, 10);
            } else {
              this.flightType[2].amount += parseInt(element.accident, 10);
            }
          });
        });
    },
    changeDate(period, compare) {
      if (period) {
        if (compare) {
          if (period.startDate != this.compareStartDate) {
            this.$refs.compareStartDate.setDefaultData(period.startDate);
          }
          if (period.endDate != this.compareEndDate) {
            this.$refs.compareEndDate.setDefaultData(period.endDate);
          }
        } else {
          if (period.startDate != this.startDate) {
            this.$refs.startDate.setDefaultData(period.startDate);
          }
          if (period.endDate != this.endDate) {
            this.$refs.endDate.setDefaultData(period.endDate);
          }
        }
      }
    }
  },
  watch: {
    // startDate() {
    //   if(!this.isInitial) {
    //     this.getCompareAccident();
    //     this.getMostAccidentRoute();
    //   }
    // },
    // endDate() {
    //   if(!this.isInitial) {
    //     this.getCompareAccident();
    //     this.getMostAccidentRoute();
    //   }
    // },
    // compareStartDate() {
    //   if(!this.isInitial) {
    //     this.getCompareAccident();
    //   }
    // },
    // compareEndDate() {
    //   if(!this.isInitial) {
    //     this.getCompareAccident();
    //   }
    // },
  }
};
</script>

<style scoped>
.inverted {
  -webkit-filter: invert(100%);
  filter: invert(100%);
}

.bottom-header:first-of-type {
  border: 1px solid #880201;
}
.bottom-header {
  border: 1px solid #880201;
  border-left: none;
  font-size: 28px;
}
.bottom-content:first-of-type {
  border: 1px solid #880201;
  border-top: none;
}
.bottom-content {
  border: 1px solid #880201;
  border-top: none;
  border-left: none;
}
.accident-year-count {
  background-color: #c3b3d0;
  border-radius: 5px;
}
</style>
